export default __webpack_public_path__ + "static/media/Neo.cfdaf20c.webp";